import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';
import './SocialCommentContainer.scss';
export default class SocialCommentContainer {
  mDiv: JQuery<HTMLElement>;
  constructor() {}
  initialize(aConstructorParams): void {
    let text = aConstructorParams.text;
    let commentCount = aConstructorParams.count;
    let parentContainer = aConstructorParams.container;
    this.mDiv = $(
      HGEN.tree({
        style: 'social_comment_container',
        children: [
          {
            style: 'social_comment_container_icon',
            interior: HGEN.faicon({
              style: FontAwesomeConfigurations.ICON_COMMENT_REGULAR,
            }),
          },
          {
            style: 'social_comment_container_count',
            interior: commentCount,
          },
          { style: 'social_comment_container_text', interior: text },
        ],
      }),
    );
    parentContainer.append(this.mDiv);
  }
}
